<!-- Cálculo do imposto -->
<div class="sub-section-container sub-secao-tributos">
  <div class="sub-section-title">
    <mat-icon class="material-symbols-outlined">calculate</mat-icon>
    <span>Cálculo do imposto</span>
  </div>

  <div class="row">
    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor IPI</mat-label>
        <input matInput [value]="totais.valorIpi | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor ICMS ST + FCP ST</mat-label>
        <input matInput [value]="totais.valorIcmsSt | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor ICMS + FCP</mat-label>
        <input matInput [value]="totais.valorIcms | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor PIS</mat-label>
        <input matInput [value]="totais.valorPis | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor COFINS</mat-label>
        <input matInput [value]="totais.valorCofins | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>
  </div>

  <p class="vtr-nota">
    ICMS, IPI, PIS e COFINS são informativos e não entram no total do documento: o efeito
    deles é na emissão fiscal.
  </p>
</div>

<!-- Reforma tributária -->
<div class="sub-section-container sub-secao-tributos">
  <div class="sub-section-title">
    <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
    <span>Reforma tributária</span>
  </div>

  <div class="row">
    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor IBS estadual</mat-label>
        <input matInput [value]="totais.valorIbsEstadual | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor IBS municipal</mat-label>
        <input matInput [value]="totais.valorIbsMunicipal | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>IBS total</mat-label>
        <input matInput [value]="totais.valorIbsTotal | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor CBS</mat-label>
        <input matInput [value]="totais.valorCbs | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>
  </div>
</div>

<!-- ICMS DIFAL -->
<div class="sub-section-container sub-secao-tributos">
  <div class="sub-section-title">
    <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
    <span>ICMS DIFAL</span>
  </div>

  <div class="row">
    <div class="col-6 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Difal não contribuinte</mat-label>
        <input matInput [value]="totais.valorDifal | abnt: 'preco' : 2" disabled class="vtr-num">
      </mat-form-field>
    </div>
  </div>
</div>
